import React from "react";
import RoundedLoader from "../loaders/RoundedLoader";

interface TertiaryButtonProps {
  buttonName: string;
  id: string;
  handleClick?: () => void;
  className?: string;
  loading?: boolean;
  testId?: string;
}

const TertiaryButton: React.FC<TertiaryButtonProps> = ({
  buttonName,
  id,
  testId,
  handleClick,
  className,
  loading,
}) => {
  return (
    <>
      {loading ? (
        <RoundedLoader />
      ) : (
        <button
          className={`p-2.5 text-p_primary font-medium subTitle flex items-center cursor-pointer ${className}`}
          id={id}
          type="button"
          onClick={handleClick}
          data-testid={testId || id}
        >
          {buttonName}
        </button>
      )}
    </>
  );
};

export default TertiaryButton;
